import addBorderInHighContrastMode from '@/lib/styling/addBorderInHighContrastMode';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import mediaQuery from '@/lib/styling/mediaQuery';
import styled from '@emotion/styled';

export const ConnectedAccountWrapper = styled('div')({
  marginTop: 24,
  h3: {
    marginBottom: 8,
    display: 'flex',
    alignItems: 'center',
  },
});

export const ConnectedAccountBox = styled('article')(
  ({ theme }) => ({
    padding: 12,
    backgroundColor: theme.palette.action.hover,
    borderRadius: 4,
    display: 'flex',
    alignItems: 'center',
    '> div': {
      marginRight: 'auto',
      display: 'flex',
      alignItems: 'center',
    },
    [mediaQuery(600)]: {
      display: 'block',
      '> div': {
        marginBottom: 12,
      },
    },
  }),
  addBorderInHighContrastMode,
  addHighContrastStyles(({ theme }) => ({
    backgroundColor: theme.isDark ? 'rgba(0, 0, 0, 0.2)' : 'transparent',
  })),
);

export const ConnectedAccountInfo = styled('div')(({ theme }) => ({
  h4: {
    lineHeight: 1.2,
  },
  p: {
    marginTop: 0,
    marginBottom: 0,
    fontSize: 14,
    color: theme.palette.text.secondary,
  },
}));
